import { PercentPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'pxpercent' })
export class PxPercentPipe implements PipeTransform {
  constructor(private percentPipe: PercentPipe) {}

  transform(value: number, format: string): any {
    if (isNaN(value)) return 'N/A';
    if (value > 0.01) return this.percentPipe.transform(value, format || '1.2');
    if (value > 0) return '< 1%';
    return '0%';
  }
}
